export const DESIGNATE_PAA = 'PAARegistration/DESIGNATE_PAA';
export const RESET_STATE = 'PAARegistration/RESET_STATE';
export const SET_PHONE_NUMBER = 'PAARegistration/SET_PHONE_NUMBER';
export const SET_JOB_FUNCTIONS = 'PAARegistration/SET_JOB_FUNCTIONS';
export const SET_API_LIST = 'PAARegistration/SET_API_LIST';
export const SUBMIT_TIN_REQUEST = 'PAARegistration/SUBMIT_TIN_REQUEST';
export const SET_SELF_ATTESTATION_DONE =
  'PAARegistration/SET_SELF_ATTESTATION_DONE';
export const SET_API_USE_TEXT = 'PAARegistration/SET_API_USE_TEXT';
export const SET_SELECTED_API_CODES = 'PAARegistration/SET_SELECTED_API_CODES';
